import { styled } from '@project44/manifest-ds';

const ToastContainer = styled('div', {
  textAlign: 'left',
});

const ToastTitle = styled('h3', {
  color: '$palette-grey-900',
  fontSize: '$medium',
  margin: 0,
});

const ToastDescription = styled('p', {
  color: '$palette-grey-700',
  fontSize: '$small',
  margin: 0,
});

interface IToastNotificationProps {
  title: string;
  description: string;
}

function ToastNotification({ title, description }: IToastNotificationProps) {
  return (
    <ToastContainer data-testid="toast-notification">
      <ToastTitle css={{ marginBottom: '$small' }}>{title}</ToastTitle>
      <ToastDescription>{description}</ToastDescription>
    </ToastContainer>
  );
}

export default ToastNotification;
